module.exports = __webpack_public_path__ + "static/media/key-emp-green.f4d6b26f.svg";